import React from 'react'

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
    }
    componentDidCatch(error) {
      console.log(error)
      // 你同样可以将错误日志上报给服务器
      window.eagle.notifyError(error.message || error)
    }
  
    render () {
      return this.props.children; 
    }
  }
export default ErrorBoundary